import { makeStyles } from '@material-ui/core'


const LoginTheme = makeStyles((theme) => ({
    main: {
        height: '100vh',
        background: '#577883',
        display: 'flex',
        alignItems: 'center',
    },
    grid: {
        width: '50%',
        margin: 'auto'
    },
    button: {
        backgroundColor: '#ffffff',
        border: 'none',
        color: '#696969',
        padding: '15px 71px',
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: '16px',
        margin: '0px 43%',
        borderRadius: '5px',
        textTransform: 'capitalize',
        
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#e7e7e7',
            color: '#696969',
            transition: 'all 0.2s ease',
        }
    }
}));

export default LoginTheme;